export enum VALIDATION_ERRORS {
  REQUIRED = "Toto pole je povinné",
  ONLY_NUMBERS = "Povolená jsou pouze čísla",
  LIST_SELECTION = "Vyberte položku ze seznamu",
  INVALID_DATE = "Neplatné datum",
  AT_LEAST_ONE = "Musíte vybrat jednu z možností",
  CANNOT_COMPLETE_CONTRACT = "Tato volba znemožňuje uzavření smlouvy",
  INVALID_ID = "Zadejte prosím platné RČ nebo datum narození",
  INVALID_PHONE_NUMBER = "Zadejte platné telefoní číslo"
}
